export const pt = {
  // Common
  "common.back": "Voltar",
  "common.cancel": "Cancelar",
  "common.noItems": "Nenhum item",
  "common.loading": "Carregando...",
  
  // Header
  "nav.features": "Recursos",
  "nav.howItWorks": "Como Funciona",
  "nav.pricing": "Preços",
  "nav.faq": "FAQ",
  "nav.testimonials": "Vitrine",
  "nav.contact": "Contato",
  "button.getStarted": "Começar",
  "button.loading": "Carregando...",
  
  // Auth related
  "auth.signIn": "Entrar",
  "auth.redirecting": "Redirecionando...",
  "auth.continueWithGoogle": "Continuar com Google",
  "auth.continueWithGithub": "Continuar com GitHub",
  "auth.or": "OU",
  
  // Site Title
  "site.title": "Communicate to Win",
  "site.title.first": "Communicate",
  "site.title.second": "to Win",
  "site.title.translated": "Comunicação para Vencer",
  
  // Hero Section
  "hero.title": "Assistente de Comunicação com IA",
  "hero.subtitle": "Transforme suas conversas com respostas inteligentes e conscientes do contexto que ajudam você a se comunicar de forma mais eficaz em qualquer situação.",
  "hero.cta.primary": "Começar Teste Grátis",
  "hero.cta.secondary": "Ver Demo",
  
  // Main Title
  "main.title": "Transforme Cada Resposta em uma Oportunidade",
  
  // Footer Section
  "footer.company": "Empresa",
  "footer.product": "Produto",
  "footer.support": "Suporte",
  "footer.legal": "Legal",
  "footer.contactSupport": "Contatar Suporte",
  "footer.helpCenter": "Central de Ajuda",
  "footer.apiDocs": "Documentação da API",
  "footer.statusPage": "Página de Status",
  "footer.privacyPolicy": "Política de Privacidade",
  "footer.termsOfService": "Termos de Serviço",
  "footer.cookiePolicy": "Política de Cookies",
  "footer.refundPolicy": "Política de Reembolso",
  "footer.copyright": "© 2025 DOUBLEWIND LTD. All rights reserved.",
  "footer.supportLabel": "Suporte",
  
  // Features Section
  "features.badge": "Recursos Poderosos",
  "features.title": "Tudo que Você Precisa para uma Melhor Comunicação",
  "features.subtitle": "Ferramentas abrangentes projetadas para tornar cada conversa mais eficaz e profissional.",
  "features.scenario.title": "Modelos de Cenários",
  "features.scenario.description": "Modelos pré-construídos para comunicações profissionais, pessoais, acadêmicas e empresariais.",
  "features.custom.title": "Entradas Personalizadas",
  "features.custom.description": "Cole qualquer mensagem ou conteúdo e obtenha respostas contextualmente apropriadas.",
  "features.instant.title": "Reduza o tempo de resposta em 90%",
  "features.instant.description": "Obtenha respostas criadas por IA em poucos segundos. Sem espera, apenas resultados.",
  "features.copy.title": "Copiar e Compartilhar com Um Clique",
  "features.copy.description": "Copie respostas instantaneamente ou compartilhe-as diretamente da plataforma.",
  
  // How It Works Section
  "howItWorks.badge": "Como Funciona",
  "howItWorks.title": "Três Passos Simples para uma Melhor Comunicação",
  "howItWorks.subtitle": "Nosso processo simplificado facilita a geração de respostas profissionais para qualquer situação.",
  "howItWorks.step1.title": "Selecionar Cenário",
  "howItWorks.step1.description": "Escolha o cenário de comunicação que melhor se adapta às suas necessidades.",
  "howItWorks.step2.title": "Colar Conteúdo",
  "howItWorks.step2.description": "Adicione a mensagem ou conteúdo ao qual você precisa responder.",
  "howItWorks.step3.title": "Obter Resposta IA",
  "howItWorks.step3.description": "Receba uma resposta profissional e contextual em segundos.",
  
  // Pricing Section
  "pricing.title": "Preços",
  "pricing.subtitle": "Escolha o plano que se adapta às suas necessidades de comunicação",
  "pricing.plan.free": "Free",
  "pricing.plan.pro": "Pro",
  "pricing.plan.business": "Enterprise",
  "pricing.free.price": "$0",
  "pricing.pro.price": "$9.99",
  "pricing.business.price": "$29.99",
  "pricing.period": "/mês",
  "pricing.free.description": "Perfeito para experimentar nosso serviço",
  "pricing.pro.description": "Ideal para profissionais e usuários frequentes",
  "pricing.business.description": "Para equipes e organizações",
  "pricing.popular": "Mais Popular",
  "pricing.free.feature1": "10 respostas por mês",
  "pricing.free.feature2": "Cenário básico",
  "pricing.free.feature3": "Definir e usar modelos",
  "pricing.free.feature4": "Registros de resposta histórica",
  "pricing.pro.feature1": "200 respostas por mês",
  "pricing.pro.feature2": "Cenário básico+personalizado",
  "pricing.pro.feature3": "Definir e usar modelos",
  "pricing.pro.feature4": "Registros de resposta histórica",
  "pricing.pro.feature5": "Personalização avançada",
  "pricing.business.feature1": "Respostas ilimitadas",
  "pricing.business.feature2": "Colaboração em equipe",
  "pricing.business.feature3": "Cenário básico+personalizado",
  "pricing.business.feature4": "Definir e usar modelos",
  "pricing.business.feature5": "Registros de resposta histórica",
  "pricing.business.feature6": "Personalização avançada",
  "pricing.cta.trial": "Começar Teste Grátis",
  "pricing.cta.subscribe": "Assinar",
  "pricing.cta.contact": "Contatar Vendas",
  "pricing.cta.current": "Plano Atual",
  "pricing.currentPlan": "Plano Atual:",
  "pricing.endDate": "Data de término do plano atual:",
  "pricing.autoRenewalDate": "Data de renovação automática do plano atual:",
  "pricing.answersLeft": "Respostas restantes:",
  "pricing.planName.free": "Plano Free",
  "pricing.planName.proMonthly": "Plano Pro-Mensal",
  "pricing.planName.proYearly": "Plano Pro-Anual",
  "pricing.planName.maxMonthly": "Plano Enterprise-Mensal",
  "pricing.planName.maxYearly": "Plano Enterprise-Anual",
  "pricing.autoRenews": "Sua contagem de respostas renova automaticamente em:",
  "pricing.needMore": "Precisa de mais respostas?",
  "pricing.upgradeBelow": "Atualize seu plano abaixo",
  "pricing.doNotRollOver": "Respostas não utilizadas não são transferidas",
  
  // FAQ Section
  "faq.title": "Perguntas Frequentes",
  "faq.subtitle": "Tudo o que você precisa saber sobre communicate2win",
  "faq.q1": "Quais cenários de comunicação são suportados?",
  "faq.a1": "Suportamos comunicações no local de trabalho, relacionamentos pessoais, correspondência acadêmica, atendimento ao cliente, alcance de vendas e muitos outros cenários. Nossa IA se adapta ao contexto e tom necessários para cada situação.",
  "faq.q2": "Quão rápidas são as respostas geradas?",
  "faq.a2": "Nossa IA gera respostas em poucos segundos. Priorizamos a velocidade sem comprometer a qualidade, garantindo que você obtenha respostas profissionais instantaneamente.",
  "faq.q3": "Posso cancelar minha assinatura a qualquer momento?",
  "faq.a3": "Sim, você pode cancelar sua assinatura a qualquer momento. Não há compromissos de longo prazo, e você pode fazer downgrade ou upgrade do seu plano conforme necessário.",
  "faq.q4": "Meus dados estão seguros e privados?",
  "faq.a4": "Sim, implementamos medidas de segurança abrangentes incluindo criptografia, controles de acesso e auditorias de segurança regulares. Seu conteúdo de entrada e respostas geradas são armazenados como parte do seu histórico de usuário para habilitar recursos como revisão de respostas e criação de modelos. Você pode excluir seus dados de histórico a qualquer momento através das configurações da sua conta.",
  "faq.q5": "O que acontece se eu ficar sem Replies?",
  "faq.a5": "Usuários Free precisam aguardar o próximo ciclo mensal para renovar a cota. Após fazer upgrade para Pro, se acabar as Replies você pode comprar adicionais avulsas; essas extras são válidas apenas para o ciclo mensal atual. Usuários Enterprise têm Replies ilimitadas.",
  "faq.q6": "Quais idiomas são suportados?",
  "faq.a6": "Atualmente, suportamos inglês com planos de expandir para espanhol, francês, alemão e outros idiomas principais. A IA pode lidar com comunicações multilíngues de forma eficaz.",
  
  // Testimonials Section
  "testimonials.title": "Vitrine de Comunicações",
  "testimonials.subtitle": "Mensagens públicas, e-mails e respostas aprimoradas por IA para inspirar as suas",
  "testimonials.sarah.name": "Sarah Johnson",
  "testimonials.sarah.title": "Diretora de Marketing",
  "testimonials.sarah.quote": "communicate2win transformou como eu lido com comunicações de clientes. As respostas são profissionais e me economizam horas toda semana.",
  "testimonials.michael.name": "Michael Chen",
  "testimonials.michael.title": "Gerente de Vendas",
  "testimonials.michael.quote": "Os modelos de cenários no local de trabalho são incrivelmente precisos. Minha taxa de resposta melhorou 40% desde que uso esta ferramenta.",
  "testimonials.emily.name": "Emily Rodriguez",
  "testimonials.emily.title": "Líder de Sucesso do Cliente",
  "testimonials.emily.quote": "Perfeito para lidar com situações difíceis de clientes. A IA entende contexto e tom perfeitamente.",
  
  // Interface Elements
  "interface.generating": "Gerando Resposta...",
  "interface.generate": "Gerar Resposta IA",
  "interface.processing": "Processando...",
  
  // History and Showcase
  "history.shareToShowcase": "Compartilhar na Vitrine",
  "history.showcased": "Na vitrine",
  "history.shareConfirm": "Compartilhar esta postagem na Vitrine? Esta ação não pode ser desfeita a menos que você exclua a postagem.",
  "history.sharedBy": "Compartilhado por:",
  "interface.copy": "Copiar",
  "interface.share": "Compartilhar",
  "interface.shareResponse": "Compartilhar Resposta",
  "interface.shareNative": "Compartilhar via Sistema",
  "interface.shareEmail": "E-mail",
  "interface.copyShareText": "Copiar com Link",
  "interface.shareTextCopied": "Resposta e link copiados para a área de transferência.",
  "interface.ready": "Pronto para Gerar",
  "interface.enterMessage": "Digite o conteúdo da sua mensagem e selecione um cenário para começar com respostas alimentadas por IA.",
  "interface.fast": "Rápido",
  "interface.accurate": "Preciso",
  "interface.professional": "Profissional",
  "interface.translation": "Tradução",
  "interface.responseDescription": "Aqui está uma resposta cuidadosa e profissional adaptada ao contexto:",
  "interface.multipleOptions": "Múltiplas opções de resposta:",
  "interface.option": "Opção",
  "interface.noContent": "Nenhum conteúdo disponível",
  
  // Placeholders
  "placeholder.message": "Cole a mensagem que você está respondendo, conteúdo de e-mail ou texto que você recebeu...",
  
  // Dropdowns
  "dropdown.useTemplates": "Usar Modelos",
  "dropdown.scenario": "Sem Cenário",
  "dropdown.target": "Sem Alvo",
  "dropdown.tone": "Sem Tom",
  
  // Scenario Options
  "scenario.email": "E-mail",
  "scenario.message": "Mensagem",
  "scenario.workplace": "Local de Trabalho",
  "scenario.school": "Escola",
  "scenario.home": "Casa",
  "scenario.business": "Negócios",
  "scenario.academic": "Acadêmico",
  "scenario.social": "Social",
  "scenario.formal": "Formal",
  "scenario.casual": "Casual",
  "scenario.professional": "Profissional",
  "scenario.personal": "Pessoal",
  "scenario.customerService": "Atendimento ao Cliente",
  "scenario.interview": "Entrevista",
  "scenario.presentation": "Apresentação",
  
  // Target Options
  "target.lover": "Amante",
  "target.friend": "Amigo",
  "target.boss": "Chefe",
  "target.colleague": "Colega",
  "target.classmate": "Colega de classe",
  "target.parents": "Pais",
  "target.child": "Filho",
  "target.teacher": "Professor",
  "target.student": "Estudante",
  "target.client": "Cliente",
  "target.customer": "Cliente",
  "target.stranger": "Estranho",
  "target.family": "Família",
  "target.sibling": "Irmão",
  "target.neighbor": "Vizinho",
  "target.mentor": "Mentor",
  "target.supplier": "Fornecedor",
  "target.serviceProvider": "Provedor de Serviços",
  "target.partner": "Parceiro",
  "target.subordinate": "Subordinado",
  
  // Tone Options
  "tone.humorous": "Humorístico",
  "tone.serious": "Sério",
  "tone.happy": "Feliz",
  "tone.angry": "Zangado",
  "tone.mischievous": "Travesso",
  "tone.polite": "Educado",
  "tone.casual": "Casual",
  "tone.formal": "Formal",
  "tone.friendly": "Amigável",
  "tone.confident": "Confiante",
  "tone.apologetic": "Desculpando-se",
  "tone.enthusiastic": "Entusiasmado",
  
  // Status Messages
  "status.copied": "Copiado!",
  "status.copyDescription": "Resposta copiada para a área de transferência.",
  "status.copyWithTranslationDescription": "Resposta e tradução copiadas para a área de transferência.",
  "status.success": "Resposta gerada com sucesso.",
  "status.successWithTranslation": "Resposta gerada com tradução.",
  "status.successWithoutTranslation": "Resposta gerada com sucesso.",
  "status.error": "Geração falhou",
  "status.errorDescription": "Falha ao gerar resposta. Por favor, tente novamente.",
  "status.enterContent": "Por favor, digite o conteúdo",
  "status.enterContentDescription": "Adicione a mensagem que você quer responder.",
  
  // Pro/Max subscriber restrictions
  "restriction.descriptionOptional": "Descrição (opcional)",
  "restriction.descriptionLabel": "Descrição (Apenas para assinantes Pro / Enterprise)",
  "restriction.proMaxOnly": "* Apenas para assinantes Pro / Enterprise",
  "restriction.desPrompt": "Digite contexto, informações de fundo ou requisitos específicos que podem ajudar a gerar melhores respostas...",
  
  // Demo functionality for non-logged-in users
  "demo.title": "Selecione uma mensagem para responder",
  "demo.option1": "Abertura de vendas (abordagem fria)",
  "demo.option2": "Lidar com uma sondagem \"seu preço é alto\"",
  "demo.option3": "Auto-apresentação de entrevista (versão de 30 segundos)",
  "demo.option4": "Resposta por e-mail",
  "demo.option5": "Acompanhamento para um prospecto \"lido-mas-sem-resposta\"",
  "demo.option6": "Elevator pitch (30 segundos)",
  "demo.runDemo": "Executar Demo",
  "demo.inputContent": "Conteúdo de Entrada:",
  "demo.scenario": "Cenário:",
  "demo.target": "Alvo:",
  "demo.tone": "Tom:",
  "demo.description": "Descrição:",

  // User Menu
  "userMenu.myAccount": "Minha Conta",
  "userMenu.history": "Histórico",
  "userMenu.templates": "Modelos",
  "userMenu.signOut": "Sair",
  
  // Hero Showcase / Demo Tabs / Previews
  "hero.preview.aiReply": "Prévia de Resposta IA",
  "hero.preview.scenarioLabel": "Cenário",
  "hero.cta.tryNow": "Começar Grátis",
  "hero.cta.learnMore": "Saber Mais",
  "hero.cta.getStarted": "Começar Grátis",
  "hero.preview.primary": "Polir Tom",
  "hero.preview.secondary": "Traduzir",
  "hero.preview.tone": "Amigável",
  "hero.preview.target": "Cliente",
  "hero.hook": "Junte-se a milhares de usuários melhorando sua comunicação todos os dias.",
  "hero.headline": "Assistente de Comunicação com IA",
  "hero.subheadline": "Transforme ideias brutas em respostas polidas e conscientes do contexto em segundos.",
  
  // Stats
  "stats.users": "Usuários",
  "stats.replies": "Respostas",
  "stats.languages": "Idiomas",
  
  // Marquee / Logos
  "marquee.trusted": "Parceiros / Suporte",
  "marquee.aria": "Logos de marcas",
  
  // Interface Elements (additional)
  "interface.advancedOptions": "Opções Avançadas",
  "interface.clearInput": "Limpar Entrada",
  "interface.clearDescription": "Limpar Descrição",
  
  // Demo short tab titles (mapped from demo option ids)
  "demo.shortTitle.salesOpener": "Abertura de vendas",
  "demo.shortTitle.priceObjection": "Sondagem de preço",
  "demo.shortTitle.interviewIntro": "Intro de entrevista",
  "demo.shortTitle.emailReply": "Resposta de e-mail",
  "demo.shortTitle.followUp": "Acompanhamento",
  "demo.shortTitle.elevatorPitch": "Elevator pitch",
  
  // Demo path / response overlay
  "demoTabs.pathPrefix": "demo",
  "demoTabs.response": "response",
  "demoTabs.inputPrompt": "Prompt de Entrada",
  "demoTabs.context": "Contexto",
  "demoTabs.description": "Descrição",
  "demoTabs.generate": "Gerar",
  "demoTabs.aiOutput": "Saída IA",
  "demoTabs.sample": "amostra",
  "demoTabs.streaming": "Streaming tokens...",
  
  // Preview sections
  "preview.section.scenarioTemplates.title": "Cenários & Modelos",
  "preview.section.scenarioTemplates.subtitle": "Escolha rapidamente um cenário ou aplique um modelo salvo. Modelos preenchem descrição/alvo/tom para que você inicie geração de alta qualidade instantaneamente.",
  "preview.section.customInputs.title": "Entradas Personalizadas",
  "preview.section.customInputs.subtitle": "Entrada principal + descrição opcional + seletores avançados de Cenário/Alvo/Tom. Combine livremente para resultados conscientes do contexto.",
  "preview.section.cutReplyTime.title": "Reduza Tempo de Resposta em 90%",
  "preview.section.cutReplyTime.subtitle": "Compare rascunho manual vs assistência IA. Opções paralelas + tradução integrada reduzem loops de revisão.",
  "preview.section.copyShare.title": "Copiar e Compartilhar com Um Clique",
  "preview.section.copyShare.subtitle": "Múltiplas opções dispostas com ações superiores unificadas: copiar tudo / compartilhar / cópia por opção. Tradução anexada automaticamente.",
  
  "preview.templates.my": "Meus Modelos",
  "preview.templates.new": "Novo",
  "preview.manualFlow": "Fluxo Manual",
  "preview.aiAssisted": "Assistido por IA",
  
  // Manual flow bullet steps
  "preview.manualFlow.step1": "Planejar estrutura e tom",
  "preview.manualFlow.step2": "Rascunhar abertura / deletar e reescrever",
  "preview.manualFlow.step3": "Ajustar polidez e gramática",
  "preview.manualFlow.step4": "Procurar palavras + verificar tradução",
  "preview.manualFlow.step5": "Colar no app de destino",
  
  "preview.copyAll": "Copiar Tudo",
  "preview.share": "Compartilhar",
  "preview.enPlusTranslation": "PT + Tradução",
  "preview.translationAppendNote": "(*) Tradução é anexada automaticamente ao copiar tudo.",
  "preview.field.scenario": "Cenário",
  "preview.field.target": "Alvo",
  "preview.field.tone": "Tom",
  "preview.auto": "Auto",
  "preview.step.pasteOrTemplate": "Colar solicitação ou escolher modelo",
  "preview.step.optionalDescription": "(Opcional) adicionar descrição / cenário",
  "preview.step.pickOption": "Escolher uma opção gerada",
  "preview.step.copyShareTranslate": "Copiar / compartilhar / traduzir com um clique",
  "preview.time.manual": "5–8 min",
  "preview.time.ai": "30–40 seg",
  
  // Additional missing keys
  "auth.consent.prefix": "Ao prosseguir, você concorda com nossos",
  "auth.consent.terms": "Termos",
  "auth.consent.and": "e",
  "auth.consent.privacy": "Política de Privacidade",
  
  "testimonials.more": "Clique na galeria para explorar a vitrine completa",
  
  "history.loadMoreButton": "Carregar Mais",
  
  "pricing.willCancelOn": "Será cancelado em:",
  "pricing.downgradeScheduled": "Downgrade agendado. Mudará para",
  "pricing.on": "em:",
  "pricing.upgradeImmediateTitle": "Plano atualizado",
  "pricing.upgradeImmediateDesc": "Seu novo plano está agora ativo.",
  "pricing.downgradeScheduledTitle": "Downgrade agendado",
  "pricing.downgradeScheduledDesc": "Seu plano mudará na próxima renovação.",
  "pricing.cancelScheduledTitle": "Cancelamento agendado",
  "pricing.cancelScheduledDesc": "Seu plano terminará na data de fim do período.",
  "pricing.cancelResumedTitle": "Cancelamento removido",
  "pricing.cancelResumedDesc": "Sua assinatura continuará renovando.",
  "pricing.cancelPendingDowngrade": "Cancelar",
  "pricing.pendingDowngradeCanceledTitle": "Downgrade pendente cancelado",
  "pricing.pendingDowngradeCanceledDesc": "Seu plano permanecerá inalterado.",
  "pricing.pendingDowngradeCancelFailedTitle": "Cancelamento falhou",
  "pricing.pendingDowngradeCancelFailedDesc": "Não foi possível cancelar o downgrade pendente. Tente novamente.",
  "pricing.cancelPendingDowngradeProcessing": "Processando...",
  "pricing.scheduled": "Agendado",
  "pricing.processing": "Processando...",
  "pricing.getMoreReplies": "Obter Mais Respostas",
  "pricing.oneTimeTitle": "Adicionar mais respostas à sua conta",
  "pricing.oneTimeAmountLabel": "Valor (USD)",
  "pricing.repliesUnit": "Respostas",
  "pricing.oneTimeNotice": "O número de respostas que você compra é válido apenas para o ciclo mensal atual. Uma assinatura paga ativa é necessária para usá-las e respostas não utilizadas não são transferidas.",
  "pricing.cancel": "Cancelar",
  "pricing.proceed": "Prosseguir",
  "pricing.confirmUpgradeTitle": "Confirmar Upgrade",
  "pricing.confirmDowngradeTitle": "Confirmar Downgrade",
  "pricing.confirmUpgradeDesc": "Você está prestes a fazer upgrade do seu plano. A mudança entra em vigor imediatamente e uma cobrança proporcional (ou crédito) pode ser aplicada.",
  "pricing.confirmDowngradeDesc": "Você está prestes a agendar um downgrade. Seus recursos atuais permanecem até o final do período de cobrança atual.",
  "pricing.downgradeEffectNote": "Downgrade não reembolsa o ciclo atual.",
  "pricing.downgradeApplyNextCycle": "O novo plano começará automaticamente na renovação.",
  "pricing.confirmCancel": "Voltar",
  "pricing.confirmProceedUpgrade": "Fazer Upgrade Agora",
  "pricing.confirmProceedDowngrade": "Agendar Downgrade",
  
  // Showcase Page
  "showcase.title": "Vitrine de Comunicações",
  "showcase.subtitle": "Descubra comunicações inspiradoras alimentadas por IA compartilhadas por nossa comunidade",
  "showcase.userPrefix": "Comunicações públicas por",
  "showcase.backAll": "Voltar para Toda Vitrine",
  "showcase.sortBy": "Ordenar por:",
  "showcase.sort.newest": "Mais Recente Primeiro",
  "showcase.sort.oldest": "Mais Antigo Primeiro",
  "showcase.sort.scenario": "Por Cenário",
  "showcase.sort.target": "Por Alvo",
  "showcase.sort.tone": "Por Tom",
  "showcase.filter.scenario": "Cenário:",
  "showcase.filter.target": "Alvo:",
  "showcase.filter.tone": "Tom:",
  "showcase.filter.all": "Todos",
  "showcase.loading": "Carregando vitrine...",
  "showcase.loadingUser": "Carregando comunicações do usuário...",
  "showcase.loadingMore": "Carregando mais...",
  "showcase.none.userTitle": "Ainda não há comunicações públicas",
  "showcase.none.globalTitle": "Ainda não há itens na vitrine",
  "showcase.none.userDesc": "Este usuário ainda não compartilhou comunicações na vitrine.",
  "showcase.none.globalDesc": "Seja o primeiro a compartilhar sua comunicação IA na vitrine!",
  "showcase.messageDetails": "Detalhes da Mensagem",
  "showcase.field.date": "Data",
  "showcase.field.scenario": "Cenário",
  "showcase.field.target": "Alvo",
  "showcase.field.tone": "Tom",
  "showcase.originalMessage": "Mensagem Original",
  "showcase.description": "Descrição",
  "showcase.aiResponse": "Resposta IA",

  // Templates
  "templates.saveAsTemplate": "Salvar como Modelo",
  "templates.saved": "Modelo Salvo",
  "templates.saveSuccess": "Modelo salvo com sucesso",
  "templates.title": "Meus Modelos",
  "templates.new": "Novo Modelo",
  "templates.loading": "Carregando...",
  "templates.none": "Nenhum modelo encontrado",
  "templates.name": "Nome",
  "templates.scenario": "Cenário",
  "templates.target": "Alvo",
  "templates.tone": "Tom",
  "templates.description": "Descrição",
  "templates.save": "Salvar",
  "templates.saving": "Salvando...",
  "templates.delete": "Excluir Modelo",
  "templates.deleteConfirm": "Excluir este modelo?",
  "templates.deleteFailed": "Falha ao excluir modelo",
  "templates.nameRequired": "* Por favor, digite o nome do modelo",
  "templates.deleteSuccess": "Modelo excluído com sucesso",
  "templates.saveFailed": "Falha ao salvar modelo",

  // History Modal additions
  "history.messageDetails": "Detalhes da Mensagem",
  "history.messageDetailsDesc": "Visualize e gerencie os detalhes da sua mensagem, incluindo a entrada original e resposta gerada por IA.",
  "history.field.date": "Data",
  "history.field.scenario": "Cenário",
  "history.field.target": "Alvo",
  "history.field.tone": "Tom",
  "history.originalMessage": "Mensagem Original",
  "history.aiResponse": "Resposta IA",
  "history.description": "Descrição",
  "history.listTitle": "Histórico de Mensagens",
  "history.listDesc": "Navegue, filtre e gerencie seu histórico de conversas. Clique em qualquer mensagem para ver detalhes.",
  "history.sortBy": "Ordenar por:",
  "history.sort.newest": "Mais Recente Primeiro",
  "history.sort.oldest": "Mais Antigo Primeiro",
  "history.sort.scenario": "Por Cenário",
  "history.sort.target": "Por Alvo",
  "history.sort.tone": "Por Tom",
  "history.filter.scenario": "Cenário:",
  "history.filter.target": "Alvo:",
  "history.filter.tone": "Tom:",
  "history.filter.all": "Todos",
  "history.loading": "Carregando histórico...",
  "history.loadingMore": "Carregando mais...",
  "history.none": "Nenhuma mensagem encontrada",
  "history.showing": "Mostrando {current} de {total} mensagens",
  "history.allLoaded": "Todas as mensagens carregadas",
  "history.scrollMore": "Role para baixo para mais",
  "history.deleteMessage": "Excluir Mensagem",
  "history.deleting": "Excluindo...",
  "history.deleteSuccess": "Registro de mensagem excluído com sucesso",
  "history.deleteFailed": "Falha ao excluir registro de mensagem, tente novamente",
  "history.confirmDeleteTitle": "Confirmar Exclusão",
  "history.confirmDeleteSubtitle": "Esta ação não pode ser desfeita",
  "history.confirmDeleteDesc": "Tem certeza de que deseja excluir este registro de mensagem?",
  "history.confirmDeleteAction": "Confirmar Exclusão",
  "history.shareTitle": "Compartilhar na Vitrine",
  "history.shareSubtitle": "Tornar esta mensagem pública",
  "history.sharing": "Compartilhando...",
  "history.confirmShareAction": "Confirmar Compartilhamento",
  "history.shareSuccess": "Mensagem compartilhada na vitrine com sucesso",
  "history.shareFailed": "Falha ao compartilhar na vitrine, tente novamente"
}